import React, { useState } from "react";
import api from "../api/axios";

function RegisterForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const passwordChecks = {
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    symbol: /[^A-Za-z0-9]/.test(password),
  };

  const isPasswordStrong = Object.values(passwordChecks).every(Boolean);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password || !name || !confirmPassword) {
      setMessage("全ての必須項目を入力してください。");
      return;
    }

    if (!isPasswordStrong) {
      setMessage("パスワードは要件をすべて満たしてください。");
      return;
    }

    if (password !== confirmPassword) {
      setMessage("パスワードが一致しません。");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const res = await api.post(`/api/auth/register`, {
        email,
        password,
        name,
      });
      setMessage(res.data.message);
      setEmail("");
      setPassword("");
      setConfirmPassword("");
      setName("");
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.message || "エラーが発生しました。");
    } finally {
      setLoading(false);
    }
  };

  const renderCheck = (label, valid) => (
    <li style={{ color: valid ? "green" : "gray" }}>✔ {label}</li>
  );

  return (
    <div style={{ maxWidth: 400, margin: "0 auto", padding: 20 }}>
      <h2 style={{ marginBottom: 20 }}>ユーザー登録</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 10 }}>
          <label>メールアドレス *</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ width: "100%", padding: 8 }}
          />
        </div>
        <div style={{ marginBottom: 10 }}>
          <label>氏名 *</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            style={{ width: "100%", padding: 8 }}
          />
        </div>
        <div style={{ marginBottom: 5, position: "relative" }}>
          <label>パスワード *</label>
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ width: "100%", padding: 8 }}
          />
          <span
            onClick={togglePasswordVisibility}
            style={{
              position: "absolute",
              right: 10,
              top: 35,
              cursor: "pointer",
              color: "#007bff",
              fontSize: 12,
            }}
          >
            {showPassword ? "非表示" : "表示"}
          </span>
        </div>

        {/* 説明とリアルタイムチェック */}
        <div style={{ fontSize: "12px", color: "#555", marginBottom: 5 }}>
          ※8文字以上で、大文字・小文字・数字・記号を含めてください。
        </div>
        <ul style={{ fontSize: "12px", marginTop: 0, marginBottom: 10, paddingLeft: 20 }}>
          {renderCheck("8文字以上", passwordChecks.length)}
          {renderCheck("大文字を含む（例：A）", passwordChecks.upper)}
          {renderCheck("小文字を含む（例：a）", passwordChecks.lower)}
          {renderCheck("数字を含む（例：1）", passwordChecks.number)}
          {renderCheck("記号を含む（例：!@#）", passwordChecks.symbol)}
        </ul>

        <div style={{ marginBottom: 20 }}>
          <label>パスワード確認 *</label>
          <input
            type={showPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            style={{ width: "100%", padding: 8 }}
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "10px",
            background: "#007bff",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          {loading ? "登録中..." : "登録"}
        </button>
      </form>
      {message && <p style={{ marginTop: 10, color: "red" }}>{message}</p>}
    </div>
  );
}

export default RegisterForm;